import React from "react"
//import I18n from "i18n-js/index.js.erb"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"

export default class SendEmailWarningModal extends React.Component {
  constructor(props){
    super(props);
    this.state = {
    };
  };

  // Render Functions  //

  render(){
    return (
      <div>
        {/* <ModalButtons buttons={this.setButtons()} /> */}
        {this.renderModalBody()}
      </div>
    );
  };

  renderModalBody() {
    return (
      <div className="modal-body">
        <div className="col-sm-12 FeeBuilderUpdateFolioItems">
           <div className="row">
             <div className="folio-items-alert" >{I18n.t('send_email_alert')}</div>
           </div>
           <br />
           <div className="row">
             <div className="form-group">
               <label >{I18n.t('send_email')}?</label>
               <select className="form-control" value={this.props.sendEmail || ''} onChange={this.props.onChangeSendEmail}>
                 <option value="" disabled>{I18n.t("select_ellipsis")}</option>
                 <option value="yes">{I18n.t('yes')}</option>
                 <option value="no">{I18n.t('no')}</option>
               </select>
               {/* <Switch onText="yes" switchId="update-folio-items-switch" offText="no" value={this.props.updateFolioItems} onChange={this.props.onChangeUpdateFolioItems} /> */}
               <LoadingSpinner show={this.props.loading} />
             </div>
           </div>
         </div>



      </div>
    );
  }


}